module.exports = __webpack_public_path__ + "static/img/productpages.ba6cf92d.png";